import {Course, CourseLike} from '.';
import {Fields} from '@vuex-orm/core';
import {RawSection} from '@/courses/types/RawSection';

type NoRelationshipsCourseSection = Omit<
  RawSection,
  'courseLikeAssignments' | 'courseRoles' | 'sections'
>;

/**
 * CourseSection class
 */
export class CourseSection extends CourseLike implements NoRelationshipsCourseSection {
  static entity = 'CourseSection';

  parentId!: number;

  static fields(): Fields {
    return {
      ...super.fields(),
      // TODO: this will only work so long as subsections aren't used
      parent: this.belongsTo(Course, 'parentId'),
    };
  }

  /**
   * @deprecated
   */
  get title(): string {
    return this.name;
  }
}

export default CourseSection;
